import React, { useState, useEffect, useCallback } from "react";
import Login from "./Login";
import Settings from "./Settings";
import ClientsList from "./ClientsList";
import Grouping from "./Grouping";
import EmailTemplates from "./EmailTemplates";
import Users from "./Users";
import ChangePasswordModal from "./ChangePasswordModal";
import { getToken, clearToken, apiFetch } from "./api";

export default function App() {
  const [loggedIn, setLoggedIn] = useState(() => !!getToken());
  const [account, setAccount] = useState(null);
  const [selectedClient, setSelectedClient] = useState(null);
  const [showSettings, setShowSettings] = useState(false);
  const [showGrouping, setShowGrouping] = useState(false);
  const [showTemplates, setShowTemplates] = useState(false);
  const [showUsers, setShowUsers] = useState(false);
  const [showPassword, setShowPassword] = useState(false);

  // Who am I — drives which actions are offered. The backend enforces the
  // real permissions; this only decides what is shown.
  const loadAccount = useCallback(() => {
    apiFetch("/api/me")
      .then((res) => (res.ok ? res.json() : null))
      .then((data) => setAccount(data || null))
      .catch((err) => console.error("Failed to load account", err));
  }, []);

  useEffect(() => {
    if (loggedIn) loadAccount();
    else setAccount(null);
  }, [loggedIn, loadAccount]);

  if (!loggedIn) {
    return (
      <Login
        onLogin={() => {
          setLoggedIn(true);
        }}
      />
    );
  }

  const passwordModal = showPassword ? (
    <ChangePasswordModal onClose={() => setShowPassword(false)} />
  ) : null;

  if (showSettings) {
    return (
      <>
        <Settings
          client={selectedClient}
          onBack={() => {
            setShowSettings(false);
            setSelectedClient(null);
          }}
        />
        {passwordModal}
      </>
    );
  }

  if (showGrouping) {
    return (
      <>
        <Grouping onBack={() => setShowGrouping(false)} />
        {passwordModal}
      </>
    );
  }

  if (showTemplates) {
    return (
      <>
        <EmailTemplates onBack={() => setShowTemplates(false)} />
        {passwordModal}
      </>
    );
  }

  if (showUsers) {
    return (
      <>
        <Users account={account} onBack={() => setShowUsers(false)} />
        {passwordModal}
      </>
    );
  }

  return (
    <>
      <ClientsList
        account={account}
        onSelectClient={(client) => {
          setSelectedClient(client);
          setShowSettings(true);
        }}
        onGrouping={() => {
          setShowGrouping(true);
        }}
        onTemplates={() => {
          setShowTemplates(true);
        }}
        onUsers={() => {
          setShowUsers(true);
        }}
        onChangePassword={() => {
          setShowPassword(true);
        }}
        onLogout={() => {
          clearToken();
          setLoggedIn(false);
          setAccount(null);
          setShowSettings(false);
          setShowGrouping(false);
          setShowTemplates(false);
          setShowUsers(false);
          setSelectedClient(null);
        }}
      />
      {passwordModal}
    </>
  );
}
